module.exports = __webpack_public_path__ + "img/1.a0d93d62.png";